module.exports = __webpack_public_path__ + "static/media/beans-receive.28cbe4a4.jpg";